import { useState } from "react";
import { NoItemCard } from "../general/misc/NoItemCard";
import { useNavigate } from "react-router-dom";
import GenericJacket from "../../assets/GenericJacket.png";
import { CONFIG } from "../../config";

export const LookbookCard = ({ lookbook = null }) => {
	const navigate = useNavigate();

	return !lookbook ? (
		<NoItemCard />
	) : (
		<div
			onClick={() => navigate(`/lookbook/${lookbook.lookbook_id}`)}
			className={`relative flex flex-col w-full h-full transition-border duration-75 flex-shrink items-center justify-center border border-transparent select-none  rounded-sm py-2 px-1 
        hover:border-gray-400 cursor-pointer
      `}
		>
			<div className="flex w-full h-full justify-center relative rounded-md p-2 items-center mb-2">
				<img
					className={`w-full h-32 sm:h-32 md:h-48 lg:h-64 xl:h-72 2xl:h-72 transition-border duration-75 object-contain rounded-md`}
					src={`${CONFIG.IMAGE_URL}${lookbook.lookbook_image_name}`}
				/>
			</div>
			<div className="flex flex-col w-full items-center text-center text-sm font-light mb-1">
				<div className="w-full font-normal">
					{lookbook.lookbook_name}
				</div>
				<div className="w-full text-xs truncate">
					{lookbook.outfit_count}{" "}
					{lookbook.outfit_count == 1 ? "outfit" : "outfits"}
				</div>
			</div>
		</div>
	);
};
